module.exports = __webpack_public_path__ + "img/ss_pink-05.b9d58d5e.jpg";